import toast from 'izitoast'

/**
 * Alert manager to show alerts and notifications.
 *
 * @type {{show: AlertManager.show, error: AlertManager.error, success: AlertManager.success, throwError:
 *     AlertManager.throwError}}
 */
export const AlertManager = {
	/**
	 * Shows the alert message.
	 *
	 * @param message
	 * @param options
	 */
	show: function(message, options) {
		options = $.extend({
			title: '',
			message: message,
			icon: 'far fa-check-circle',
			displayMode: 'replace',
			position: 'bottomCenter',
			image: null,
			balloon: false,
			progressBar: false,
			timeout: 2200,
			layout: 2,
			theme: 'dark',
		}, options)
		
		
		toast.show(options)
	},
	/**
	 * Show an error alert.
	 *
	 * @param message
	 * @param options
	 */
	error: function(message, options) {
		options = $.extend({
			title: '',
			message: message,
			position: 'bottomCenter',
			layout: 2,
			timeout: 2200,
		}, options)
		
		toast.error(options)
	},
	/**
	 * Show success alert.
	 *
	 * @param message
	 * @param options
	 */
	success: function(message, options) {
		options = $.extend({
			title: '',
			message: message,
			position: 'bottomCenter',
			layout: 2,
			timeout: 2200,
		}, options)
		
		this.notification(message, options)
	},
	/**
	 * Show error alert, similar to showError but also logs the error to the browser's console.
	 *
	 * @param message
	 * @param options
	 */
	throwError: function(message, options) {
		if(App.DEBUG || (options && options.force)) {
			console.error(message)
			this.error(message, options)
		}
	},
	
	notification: function(message, options) {
		options = $.extend({
			title: '',
			message: message,
			icon: 'far fa-check-circle',
			displayMode: 'replace',
			position: 'bottomCenter',
			image: null,
			balloon: false,
			progressBar: false,
			timeout: 2200,
			layout: 2,
			theme: 'dark',
		}, options)
		
		toast.show(options)
	},
}
